import { IPrepaySettingsActions } from "./IPrepaySettingsActions";
import * as ActionTypes from "./PrepaySettingsActionsTypes";
import { IRestaurantsSettingsActions } from "../restaurantsSettings/IRestaurantsSettingsActions";

/** @description Переключение типа графика приёма предоплат */
export function switchPrepaySchedule(
  isActiveRestaurantSchedule: boolean,
): IPrepaySettingsActions {
  return {
    type: ActionTypes.SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST,
    payload: {
      isActiveRestaurantSchedule,
    },
  };
}

/** @description Успешное переключение типа графика приёма предоплат */
export function switchPrepayScheduleSuccess(
  isActiveRestaurantSchedule: boolean,
): IPrepaySettingsActions {
  return {
    type: ActionTypes.SWITCH_PREPAY_SCHEDULE_TYPE_SUCCESS,
    payload: {
      isActiveRestaurantSchedule,
    },
  };
}

/** @description Обработка ошибки переключения типа графика приёма предоплат */
export function switchPrepayScheduleError(): IPrepaySettingsActions {
  return {
    type: ActionTypes.SWITCH_PREPAY_SCHEDULE_TYPE_ERROR,
    error: "Не удалось переключить тип приёма резервов",
  };
}

export function switchSectionId(
  sectionId: number | undefined,
): IRestaurantsSettingsActions {
  return {
    type: ActionTypes.SET_SECTION_ID,
    payload: {
      sectionId,
    },
  };
}
